module.exports = __webpack_public_path__ + "assets/a6ddf2b7d4f4b9cf4fed06e4981bffa5.png";